import isEmpty from "lodash/isEmpty";
import { fork, put, takeLatest } from "redux-saga/effects";

import { callApi } from "../../../sagas/helpers/api";
import { setError, setSuccess, startLoading } from "../../../store/appSlice";
import * as PaymentsApi from "../api/Payments";
import { fetchTransactions, setPaginatedList } from "./transactions.slice";

import type { PayloadAction } from "@reduxjs/toolkit";
import type { PaymentsQueryParams } from "../models/Payment";

function* fetchTransactionsSaga({
  payload,
}: PayloadAction<PaymentsQueryParams>) {
  const operationPath = "transactions.list";

  yield put(startLoading(operationPath));
  try {
    const { page = 1, statuses, ...rest } = payload;
    // @ts-ignore noImplicitAny
    const data = yield callApi(PaymentsApi.getPayments, {
      ...rest,
      page,
      statuses: !isEmpty(statuses) ? statuses : null,
    });

    yield put(setPaginatedList(data));
    yield put(setSuccess(operationPath));
  } catch (error) {
    console.error(error);
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* watchFetchTransactions() {
  yield takeLatest(fetchTransactions.type, fetchTransactionsSaga);
}

export default function* rootSaga() {
  yield fork(watchFetchTransactions);
}
